var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#151515}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-in",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_61",
    fill: "none",
    d: "M0 0h24v24H0z",
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ilustra",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    transform: "translate(6.507 13.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    d: "M13.287 20.067h-3.253A2.036 2.036 0 018 18.034v-1.627a.407.407 0 01.813 0v1.627a1.222 1.222 0 001.22 1.22h3.254a.407.407 0 110 .813z",
    className: "cls-2",
    transform: "translate(-8 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    transform: "translate(0 8.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    d: "M8.541 10.813H.407a.407.407 0 010-.813h8.134a.407.407 0 110 .813z",
    className: "cls-2",
    transform: "translate(0 -10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    transform: "translate(11.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_33",
    d: "M15.627 19.522A1.628 1.628 0 0114 17.9V3.254a1.626 1.626 0 011.117-1.541L20 .085A1.525 1.525 0 0120.507 0a1.628 1.628 0 011.627 1.627v14.642a1.624 1.624 0 01-1.116 1.541l-4.881 1.627a1.527 1.527 0 01-.511.086zM20.507.813a.753.753 0 00-.244.041l-4.889 1.63a.811.811 0 00-.56.77V17.9a.815.815 0 00.813.813.749.749 0 00.246-.041l4.889-1.629a.814.814 0 00.56-.77V1.627a.815.815 0 00-.815-.814z",
    className: "cls-2",
    transform: "translate(-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    transform: "translate(6.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34",
    d: "M8.407 4.067A.407.407 0 018 3.66V2.034A2.036 2.036 0 0110.034 0h9.354a.407.407 0 010 .813h-9.354a1.222 1.222 0 00-1.22 1.22V3.66a.407.407 0 01-.407.407z",
    className: "cls-2",
    transform: "translate(-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    transform: "translate(4.88 4.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_35",
    d: "M6.407 13.321a.406.406 0 01-.288-.694l2.966-2.966-2.966-2.966a.407.407 0 01.575-.575l3.254 3.253a.407.407 0 010 .575L6.694 13.2a.405.405 0 01-.287.121z",
    className: "cls-2",
    transform: "translate(-6 -6.001)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorIcon);
export default __webpack_public_path__ + "static/media/door-icon.85a3d84826c18176632f7042dd1587fa.svg";
export { ForwardRef as ReactComponent };